/**
 * Utility functions to populate information and symbols for each period in a rebate. 
 */


export const makePeriod = ({ name = '', startDate = '', endDate = '', formulaDescription = '', thresholdInclusive = true, tiers } = {}) => ({
    name,
    startDate,
    endDate,
    formulaDescription,
    thresholdInclusive,
    tiers: Array.isArray(tiers) && tiers.length ? tiers : [{ threshold: '', rebateValue: '' }],
});

export function getListOfPeriods(startDate, endDate, period) {

    const start = new Date(`${startDate}T00:00:00`);
    const end = new Date(`${endDate}T00:00:00`);

    if (!startDate || !endDate || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end) {
        return [];
    }

    const formatDate = (date) => date.toISOString().slice(0, 10);

    const buildPeriods = (months) => {
        const periods = [];
        let currentStart = new Date(start);

        while (currentStart <= end) {
            const currentEnd = new Date(currentStart);
            currentEnd.setMonth(currentEnd.getMonth() + months);
            currentEnd.setDate(currentEnd.getDate() - 1);

            periods.push({
                startDate: formatDate(currentStart),
                endDate: formatDate(currentEnd > end ? end : currentEnd),
            });

            currentStart = new Date(currentEnd);
            currentStart.setDate(currentStart.getDate() + 1);
        }

        return periods;
    };

    switch (period) {
        case 'monthly':
            return buildPeriods(1);
        case 'quarterly':
        case 'vendor_fiscal_quarter':
            return buildPeriods(3);
        case 'yearly':
            return buildPeriods(12);
        case 'contract_term':
            return [{ startDate: formatDate(start), endDate: formatDate(end) }];
        case 'custom': // haven't implemented custom periods 
        case 'unknown':
        default:
            return [];
    }
}

export function getPeriodName(periodType, index) {
    switch (periodType) {
        case 'monthly':
            return `Month ${index + 1}`;
        case 'quarterly':
            return `Q${index + 1}`;
        case 'yearly':
            return `Year ${index + 1}`;
        case 'contract_term':
            return 'Contract Term';
        default:
            return 'Enter Period Name';
    }
}

// Symbol for Rebate Value
export function getRebateUnitSuffix(unit) {
    if (unit === 'Flat $') return '$';
    if (unit === '% of Spend') return '%';
    if (unit === '$ Per Unit') return '$/unit';
    return '';
};

export function calculateThresholdMax(thresholdMin, nextThresholdMin) {
    const parseThreshold = (value) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const currentMin = parseThreshold(thresholdMin);
    const nextMin = parseThreshold(nextThresholdMin);

    if (nextMin == null) {
        return '';
    }

    const maxThreshold = nextMin - 1;

    if (currentMin == null) {
        return maxThreshold;
    }

    return maxThreshold < currentMin ? currentMin : maxThreshold;
}

